import React from "react";
import styles from "./OurLocations.module.css";
import Image from "next/image";

interface Data {
  title: string;
  location_cards: Card[];
  location_map_image: {
    url: string;
    alternativeText: string;
  };
}

interface Card {
  id: number;
  country_name: string;
  background_image: {
    url: string;
  };
  country_image: {
    url: string;
    alternativeText: string;
  };
  phone_email: {
    email: string;
    phone_no: string;
  };
  location: string;
}

interface LocationProps {
  className?: string;
  data: Data;
}

const OurLocations: React.FC<LocationProps> = ({ className, data }) => {
  return (
    <div className={styles.ourLocationBanner}>
      <div className="container">
        <div className={styles.locationContent}>
          <h2>{data?.title}</h2>
          <div
            className={`${styles.locationBoxContainer} ${
              className ? styles.contactBox : ""
            }`}
          >
            {data?.location_cards.map((location) => (
              <div
                key={location.id}
                className={
                  className ? styles.contactBoxCard : styles.locationBox
                }
                style={{
                  backgroundImage: `url(${location?.background_image?.url})`,
                  position: "relative",
                }}
              >
                <div className={className ? styles.overlay : ""}></div>
                <div className={styles.card}>
                  <Image
                    src={location?.country_image?.url}
                    alt={location?.country_image?.alternativeText}
                    title={location?.country_image?.alternativeText}
                    height={32}
                    width={32}
                  />
                  <span>{location?.country_name}</span>
                </div>
                <ul>
                  {location?.phone_email?.phone_no ? (
                    <li>
                      <Image
                        src="/assets/call-calling.svg"
                        alt="call"
                        title="call"
                        width={24}
                        height={24}
                      />
                      {location?.phone_email?.phone_no}
                    </li>
                  ) : (
                    ""
                  )}
                  {location?.phone_email?.email ? (
                    <li>
                      <Image
                        src="/assets/icon-mail.svg"
                        alt="email"
                        title="email"
                        width={24}
                        height={24}
                      />
                      {location?.phone_email?.email}
                    </li>
                  ) : (
                    ""
                  )}
                  {location?.location ? (
                    <li>
                      <Image
                        src="/assets/location.svg"
                        alt="location"
                        title="location"
                        width={24}
                        height={24}
                      />
                      <span>{location?.location}</span>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            ))}
            <div className={styles.locationImage}>
              <Image
                src={data?.location_map_image?.url}
                alt={data?.location_map_image?.alternativeText}
                title={data?.location_map_image?.alternativeText}
                height={300}
                width={1224}
                className="img-responsive"
              />
              <div
                className={styles.backgroudMapImage}
                style={{
                  backgroundImage: `url(${data?.location_map_image?.url})`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurLocations;
